import {
    Component,
    ChangeDetectionStrategy,
    SimpleChanges,
    Input,
    ChangeDetectorRef,
    OnChanges,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PersonService } from '../../../core/api/person.service';
import { PersonDto } from '../../../core/dto/person';
import { NotificationService } from '../../../core/services/notification.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { ChangesService } from '../../../core/changes-warning/changes.service';

@Component({
    selector: 'isav-people-edit-credentials',
    templateUrl: './people-edit-credentials.html',
    styleUrls: ['./people-edit-credentials.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleEditCredentials implements OnChanges, OnInit, OnDestroy {
    @Input() value: PersonDto;

    emailControl = new UntypedFormControl(null);
    passwordForm = new UntypedFormGroup({
        previousPassword: new UntypedFormControl(''),
        newPassword: new UntypedFormControl(''),
    });
    loading: boolean = false;

    constructor(
        private personService: PersonService,
        private notificationService: NotificationService,
        private _cdRef: ChangeDetectorRef,
        private router: Router,
        private authService: AuthService,
        private changesService: ChangesService
    ) {}

    ngOnInit() {
        this.changesService.connect(this.emailControl);
        this.changesService.connect(this.passwordForm);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && this.value) {
            this.emailControl.reset(this.value.email);
        }
    }

    ngOnDestroy() {
        this.changesService.disconnect(this.emailControl);
        this.changesService.disconnect(this.passwordForm);
    }

    changeEmail() {
        this.loading = true;
        const value = this.emailControl.value;
        this.personService.changeEmail(this.value['@id'], value).subscribe(
            () => {
                this.emailControl.reset(value);
                this.loading = false;
                this._cdRef.markForCheck();
                this.authService.logout();
                this.router.navigate(['/sign-in']);
                this.notificationService.add({
                    title: 'Success',
                    message: 'Successfully changed email. Log in using new credentials.',
                    type: 'success',
                    delay: 5000,
                });
            },
            () => {
                this.loading = false;
                this._cdRef.markForCheck();
            }
        );
    }

    changePassword() {
        this.loading = true;
        this.personService.selfPasswordChange(this.passwordForm.value).subscribe(
            () => {
                this.passwordForm.reset();
                this.loading = false;
                this._cdRef.markForCheck();
                this.authService.logout();
                this.router.navigate(['/sign-in']);
                this.notificationService.add({
                    title: 'Success',
                    message: 'Successfully updated password. Log in using new credentials.',
                    type: 'success',
                    delay: 5000,
                });
            },
            () => {
                this.loading = false;
                this._cdRef.markForCheck();
            }
        );
    }
}
